/* eslint-disable */

/**
* Validates an email string.
*/
export const validateEmailFormat = (email) => {
	if (!email) {
		return false;
	}
	// check if email is a string or a node.
	const emailString = typeof email === 'string' ? email : email.value;
	// eslint-disable-next-line no-useless-escape
	const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailRegex.test(emailString);
};


export const addCssClassToYoutubeIframe = () => {
	const iframes = document.querySelectorAll('iframe');

	iframes.forEach(
		(iframe) => {
			const src = iframe.getAttribute('src');
			if (src && (src.includes('youtube.com') || src.includes('youtu.be'))) {
				iframe.classList.add('yt-video-16-9');
			}
		},
	);
}
